{
  "sign_in": "Logga in",
  "sign_up": "Registrera dig",
  "signing_in": "Loggar in...",
  "signing_up": "Registrerar...",
  "minimum_8_characters": "Minst 8 tecken",
  "forgot_password": "Glömt lösenord?",
  "continue_with": "eller fortsätt med",
  "continue_with_google": "Google",
  "already_have_account": "Har du redan ett konto?",
  "dont_have_account": "Har du inget konto?",
  "completing_login": "Slutför inloggning...",
  "oauth_login_failed": "Inloggning misslyckades",
  "missing_auth_tokens": "Autentiseringstokens saknas",
  "auth_successful_but_failed_load": "Autentisering lyckades men misslyckades att ladda användardata",
  "authentication_failed": "Autentisering misslyckades",
  "enter_email_for_reset": "Ange din e-postadress så skickar vi dig en länk för att återställa ditt lösenord.",
  "send_reset_email": "Skicka återställningslänk",
  "sending_reset_email": "Skickar återställningslänk...",
  "password_reset_sent": "Lösenordsåterställning skickad",
  "check_your_email": "Kontrollera din e-post",
  "password_reset_instructions": "Vi har skickat en länk för lösenordsåterställning till din e-post. Kontrollera din inkorg och klicka på länken för att återställa ditt lösenord.",
  "back_to_login": "Tillbaka till inloggning",
  "reset_password": "Återställ lösenord",
  "enter_new_password": "Ange ditt nya lösenord nedan.",
  "new_password": "Nytt lösenord",
  "confirm_new_password": "Bekräfta nytt lösenord",
  "confirm_password": "Bekräfta lösenord",
  "resetting_password": "Återställer lösenord...",
  "password_reset_success": "Lösenord återställt",
  "invalid_or_expired_token": "Ogiltig eller utgången återställningstoken",
  "invalid_reset_link": "Ogiltig återställningslänk",
  "reset_link_expired_or_invalid": "Denna lösenordsåterställningslänk har gått ut eller är ogiltig.",
  "request_new_reset_link": "Begär ny återställningslänk",
  "password_reset_complete": "Lösenordsåterställning klar",
  "password_reset_complete_message": "Ditt lösenord har återställts framgångsrikt. Du kan nu logga in med ditt nya lösenord.",
  "continue_to_login": "Fortsätt till inloggning",
  "complete_profile_title": "Slutför din profil",
  "username": "Användarnamn",
  "username_required": "Användarnamn krävs",
  "username_length": "Användarnamnet måste vara mellan 3 och 50 tecken",
  "username_invalid": "Användarnamnet kan endast innehålla bokstäver, siffror och understreck",
  "username_taken": "Detta användarnamn är redan upptaget",
  "checking_availability": "Kontrollerar tillgänglighet...",
  "first_name": "Förnamn",
  "last_name": "Efternamn",
  "handicap": "Handikapp",
  "handicap_invalid": "Handikapp måste vara mellan -10 och 54",
  "gender": "Kön",
  "gender_not_specified": "Ej angivet",
  "gender_male": "Man",
  "gender_female": "Kvinna",
  "gender_other": "Annat",
  "complete_profile_button": "Slutför profil",
  "completing_profile": "Slutför profil...",
  "profile_completed": "Profil slutförd!",
  "profile_completion_error": "Kunde inte slutföra profilen. Försök igen.",
  "registration_successful": "Registrering lyckades!",
  "account_deleted_successfully": "Kontot har tagits bort",
  "account_deletion_failed": "Det gick inte att ta bort kontot",
  "verifying_email": "Verifierar din e-postadress...",
  "please_wait": "Vänta medan vi verifierar din e-postadress.",
  "verification_success": "E-post verifierad!",
  "verification_failed_title": "Verifiering misslyckades",
  "redirecting": "Omdirigerar dig om ett ögonblick...",
  "verify_email_title": "Kontrollera din e-post",
  "verify_email_message": "Vi skickade en verifieringslänk till",
  "verification_link_expires": "Verifieringslänken upphör att gälla om 24 timmar. Om du inte ser e-postmeddelandet, kontrollera din skräppostmapp.",
  "go_to_login": "Gå till inloggning",
  "no_account_question": "Har du inget konto?",
  "register_here": "Registrera dig här",
  "have_account_question": "Har du redan ett konto?",
  "sign_in_here": "Logga in",
  "or_divider": "ELLER",
  "login_with_ebirdie": "Logga in med eBirdie",
  "login_with_google": "Logga in med Google",
  "login_with_apple": "Logga in med Apple",
  "forgot_password_question": "Glömt ditt lösenord?",
  "reset_password_action": "Återställ lösenord",
  "validating_reset_link": "Kontrollerar länk...",
  "login_failed": "Inloggningen misslyckades",
  "too_many_attempts": "För många inloggningsförsök. Försök igen senare.",
  "ebirdie_username": "Suomi Golf ID-användarnamn",
  "ebirdie_username_placeholder": "Suomi Golf ID-användarnamn eller e-post",
  "ebirdie_invalid_credentials": "Felaktiga Golf ID-uppgifter",
  "ebirdie_service_unavailable": "Golf ID-tjänsten är inte tillgänglig. Försök igen senare.",
  "ebirdie_login_failed": "Golf ID-inloggning misslyckades",
  "ebirdie_fetch_title": "Hämtning av data från eBirdie",
  "ebirdie_fetch_description": "När du registrerar dig hämtas dina uppgifter (namn, ålder, klubb, medlemsnummer och handikapp) automatiskt från Finlands Golförbunds eBirdie-system.",
  "ebirdie_accept_terms": "Jag godkänner villkoren",
  "first_name_required": "Förnamn är obligatoriskt",
  "last_name_required": "Efternamn är obligatoriskt",
  "email_change": {
    "confirming": "Bekräftar byte av e-postadress...",
    "success_title": "E-postadress ändrad",
    "failed_title": "Bekräftelsen misslyckades",
    "go_to_app": "Gå till appen"
  }
}
